import { Component, inject } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { AutoFocusModule } from 'primeng/autofocus';
import { InputTextModule } from 'primeng/inputtext';
import { LayoutService } from 'src/app/shared/services/layout.service';

@Component({
  selector: '[app-search]',
  standalone: true,
  imports: [DialogModule, InputTextModule, AutoFocusModule],
  templateUrl: './search.component.html',
  styleUrl: './search.component.css'
})
export class SearchComponent {
  layoutService = inject(LayoutService);

  toggleSearchBar() {
      this.layoutService.layoutState.update((value) => ({ ...value, searchBarActive: !value.searchBarActive }));
  }

  get searchBarActive(): boolean {
      return this.layoutService.layoutState().searchBarActive;
  }

  set searchBarActive(_val: boolean) {
      this.layoutService.layoutState.update((prev) => ({ ...prev, searchBarActive: _val }));
  }
}
